import { InvestProjectYearSic } from './invest-sic/invest-project-year-sic';
import { InvestProjectYear } from './invest-project-year';

export class InvestProject {
    code: string;
    name: string;
    years: InvestProjectYearSic[] | InvestProjectYear[];

    constructor(name: string) {
        this.name = name;
    }
}
